import type { ApolloError } from '@apollo/client';
import { useSiteEntityQuery, SiteEntityQuery } from '@updater/consumer-graph';

type EntityBranding = NonNullable<
  NonNullable<SiteEntityQuery['siteBranding']>['entityBrandings']
>[number];

export const isEntityKindUser = (
  brandings: (EntityBranding | null)[],
  entityKind: string
) => brandings.some((branding) => branding && branding.kind === entityKind);

export const useIsEntityKindUser = (
  entityKind: string,
  inviteToken?: string
): {
  loading: boolean;
  error?: ApolloError;
  data?: boolean;
} => {
  const { data, loading, error } = useSiteEntityQuery({
    variables: { input: inviteToken ? { inviteToken } : {} },
  });

  if (data?.siteBranding?.entityBrandings) {
    return {
      loading: false,
      error,
      data: isEntityKindUser(data.siteBranding.entityBrandings, entityKind),
    };
  }

  return {
    loading,
    error,
  };
};
